// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-validator-container {
  text-align: left;
}
.password-validator-container p {
  font-weight: bold;
  padding-bottom: 0 !important;
}
.password-validator-container ul {
  margin-left: 0;
  margin-top: 0;
}
.password-validator-container ul li.invalid {
  color: var(--main-text-color);
}
.password-validator-container ul li.valid {
  color: var(--main-text-color);
}
.password-validator-container ul li {
  padding-left: 1rem;
  margin-top: 0.1rem;
  position: relative;
}
.password-validator-container ul li .fa {
  position: absolute;
  left: 0;
  top: 45%;
  transform: translateY(-50%);
}
.password-validator-container ul li .fa-circle {
  opacity: 0.4;
  font-size: 0.5rem;
  color: var(--main-text-color);
}
.password-validator-container ul li .fa-check-circle {
  color: var(--main-dark-green);
  left: -2px;
}
.password-validator-container ul li .fa-times {
  color: var(--main-red);
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/PasswordStrength/PasswordStrength.less"],"names":[],"mappings":"AAAA;EAKE,gBAAA;AAHF;AAFA;EAQI,iBAAA;EACA,4BAAA;AAHJ;AANA;EAaI,cAAA;EACA,aAAA;AAJJ;AAVA;EAiBM,6BAAA;AAJN;AAbA;EAqBM,6BAAA;AALN;AAhBA;EAyBM,kBAAA;EACA,kBAAA;EACA,kBAAA;AANN;AArBA;EA8BQ,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AANR;AA3BA;EAqCQ,YAAA;EACA,iBAAA;EACA,6BAAA;AAPR;AAhCA;EA2CQ,6BAAA;EACA,UAAA;AARR;AApCA;EAgDQ,sBAAA;AATR","sourcesContent":[".password-validator-container {\n  @varColorError: var(--main-red);\n  @varText: var(--main-text-color);\n  @varPlaceholder: var(--main-control-placeholder-color);\n\n  text-align: left;\n\n  p {\n    font-weight: bold;\n    padding-bottom: 0 !important;\n  }\n\n  ul {\n    margin-left: 0;\n    margin-top: 0;\n\n    li.invalid {\n      color: @varText;\n    }\n\n    li.valid {\n      color: @varText;\n    }\n\n    li {\n      padding-left: 1rem;\n      margin-top: .1rem;\n      position: relative;\n\n      .fa {\n        position: absolute;\n        left: 0;\n        top: 45%;\n        transform: translateY(-50%);\n      }\n\n      .fa-circle {\n        opacity: 0.4;\n        font-size: .5rem;\n        color: @varText;\n      }\n\n      .fa-check-circle {\n        color: var(--main-dark-green);\n        left: -2px;\n      }\n\n      .fa-times {\n        color: @varColorError;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
